import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Dialog from '../dialog/Dialog';
import CollectionIdentifier from './CollectionIdentifier';
import CollectionLink from './CollectionLink';
import './CollectionShareInformation.css';
import { ReactComponent as ShareIcon } from '../utilities/icons/share.svg';

const CollectionShareInformationContent = ({ identifier, isShareable }) => {
    return (
        <Container>
            <Row className="mb-4">
                <Col>
                    <CollectionIdentifier identifier={identifier} />
                </Col>
            </Row>
            {isShareable && (
                <Row className="mb-4">
                    <Col>
                        <CollectionLink identifier={identifier} />
                    </Col>
                </Row>
            )}
        </Container>
    );
};

CollectionShareInformationContent.propTypes = {
    identifier: PropTypes.string,
    isShareable: PropTypes.bool,
};

const CollectionShareInformation = ({ identifier, isShareable, title }) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);
    const headerId = useId();

    const hideDialog = () => setShow(false);
    const toggle = () => setShow(!show);

    const showButton = (
        <Button
            variant="primary"
            onClick={toggle}
            aria-label={t('collection_share_button_aria_label')}
            aria-haspopup="dialog"
            className="collection-share-button"
            size="sm"
        >
            <ShareIcon aria-hidden="true" />
            <span>{t('collection_share_information_button')}</span>
        </Button>
    );

    return (
        <Dialog showComponent={showButton} show={show} hide={hideDialog} aria-labelledby={headerId}>
            <Modal.Header id={headerId} closeButton closeLabel={t('help_dialog_close_label')}>
                {t('collection_share_information_header')} "{title}"
            </Modal.Header>
            <Modal.Body>
                <CollectionShareInformationContent
                    identifier={identifier}
                    isShareable={isShareable}
                />
            </Modal.Body>
        </Dialog>
    );
};

CollectionShareInformation.propTypes = {
    identifier: PropTypes.string,
    isShareable: PropTypes.bool,
    title: PropTypes.string,
};

export default CollectionShareInformation;
